import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import { createMap } from '../../store/actions/mapActions'

const InputField = styled.div`
margin: 20px 0;
`
const InputBox = styled.input`
background: #eee;
color: #444;
border: none;
border-bottom: 2px solid #0063c0;
font-size: 1.4em;
display: block;
`
const InputTextArea = styled.textarea`
background: #eee;
color: #444;
border: none;
border-bottom: 2px solid #0063c0;
font-size: 1.4em;
display: block;
`
const SubmitButton = styled.button`
font-size: 12px;
padding: 0.6em;
margin: 1em 0;
border: none;
background: #0063c0;
color: white;
border-radius: 0.2em;
`
const FormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 350px));
  grid-gap: 20px;
  padding: 20px;
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  background: #0063c0;
  color: #0063c0;
  margin-left: 230px;
  @media only screen and (max-width: 700px) {
    margin-left: 0;
  }
`
const FormCard = styled.div`
  background: #FFF;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11),
              0 5px 15px 0 rgba(0,0,0,0.08);
`

class CreateMap extends Component {
  state = {
    title: '',
    content: '',
    topic: '',
    numOfLinks: 1,
    savedBy: []
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.createMap(this.state);
    this.props.history.push('/');
  }
  linkFormFunction = () => {
    let linkFormArray = []

    for (let i = 1; i < this.state.numOfLinks+1; i++) {
      linkFormArray.push(
        <div>
          <h3>Link # {i}</h3>
          <InputField>
            <label htmlFor="linkTitle">Link Title</label>
            <InputBox id={`linkTitle${i}`} onChange={this.handleChange}></InputBox>
          </InputField>
          <InputField>
            <label htmlFor="link">Link URL</label>
            <InputBox id={`link${i}`} onChange={this.handleChange}></InputBox>
          </InputField>
          <InputField>
            <label htmlFor="linkDescription">Link Description</label>
            <InputTextArea id={`linkDescription${i}`} onChange={this.handleChange}></InputTextArea>
          </InputField>
      </div>
      )
    }
    return linkFormArray
  }
  increClick =()=> {
    this.setState((state) => {
      if(this.state.numOfLinks<20) {
        return {numOfLinks: state.numOfLinks+1}
      }
    })
  }
  decClick =()=> {
    this.setState((state) => {
      if(this.state.numOfLinks>0) {
        return {numOfLinks: state.numOfLinks-1}
      }
    })
  }
  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to='/signin' /> 
    return (
      <FormContainer>
        <FormCard>
          <h2>Overview:</h2>
          <InputField>
            <label htmlFor="title">Title</label>
            <InputBox type="text" id='title' onChange={this.handleChange} />
          </InputField>
          <InputField>
            <label htmlFor="content">Description</label>
            <InputTextArea id="content" onChange={this.handleChange}></InputTextArea>
          </InputField>
          <label htmlFor="topic">Topic</label>
          <div>
            <select id="topic" onChange={this.handleChange}>
              <option value="None">Choose a Topic</option>
              <option value="Code">Code</option>
              <option value="Photography">Photography</option>
              <option value="Videography">Videography</option>
              <option value="Music">Music</option>
              <option value="Food">Food</option>
            </select>
          </div>
        </FormCard>
        <FormCard>
          <h2>Where to Learn:</h2>
          {this.linkFormFunction()}
          <div>
            <h4>Number of Links {this.state.numOfLinks}</h4>
            <button onClick={this.decClick}>-</button>
            <button onClick={this.increClick}>+</button>
          </div>
          <InputField>
            <SubmitButton onClick={this.handleSubmit}>Create a New Map</SubmitButton>
          </InputField>
        </FormCard>
      </FormContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createMap: (map) => dispatch(createMap(map))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateMap)



// WEBPACK FOOTER //
// ./src/components/maps/CreateMap.js